
import { FunctionComponent } from "react";
import { Badge, styled, type BadgeProps } from "@mui/material";

export const FilterBadge: FunctionComponent<BadgeProps> = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    minWidth: "14px",
    height: "14px",
    fontSize: "8px",
    fontWeight: 600,
    padding: "2px",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}));
